import 'antd/dist/antd.variable.min.css';
import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'animate.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route} from "react-router-dom";
import {AppProvider, useApp} from "./contexts/app";
import Campaign from "./pages/Campaign";
import Question from "./pages/Question";
import Booking from "./pages/Booking";
import ProductService from "./pages/ProductService";
import ProductServiceDetail from './pages/ProductServiceDetail';
import Confirm from "./pages/Confirm";
import NotFound from "./pages/404";
import Success from "./pages/Success";
import ReAuth from "./pages/401";
import PortalCode from "./pages/Booking/portal-code";
import {ThemeProvider} from "styled-components";
import {ConfigProvider} from 'antd';
import ScrollToTop from "./components/ScrollToTop";
import AnimatedSwitch from "./contexts/animated-switch";
import {setCurrentLanguageCode} from "./services/language";
import {MaintainProvider} from "./contexts/maintain";
import OutsideCall from "./pages/OutsideCall";
import AnonymousChat from "./pages/AnonymoysChat";


const root = ReactDOM.createRoot(document.getElementById('root'));

try {
    if (navigator.userAgent.toLowerCase().indexOf("window") !== -1) {
        document.body.classList.add("window");
    }
} catch (e) {
}

if (window.location.pathname === '/') {
    const pwaStartUrl = window.localStorage.getItem('pwaStartUrl');
    if (pwaStartUrl) {
        window.location.href = pwaStartUrl;
    }
}

const App = (props: any) => {
    const {themeColors} = useApp();

    useEffect(() => {
        ConfigProvider.config({
            theme: {
                primaryColor: themeColors.main,
            },
        });
    }, [themeColors])

    useEffect(() => {
        window.document.querySelector("#loading")?.remove();
        // Set default language
        const searchParams = new URLSearchParams(window.location.search);
        const language = searchParams.get('language');
        if (language) {
            setCurrentLanguageCode(language);
        }
    }, []);

    return (
        <ThemeProvider theme={themeColors}>
            <AnimatedSwitch>

                <Route path={'/:clientCode/:campaignPath'} element={<Campaign/>}/> {/* màn hình đầu + confirm */}
                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType'}
                    element={<ProductService/>}/> {/* chọn package */}
                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId'}
                    element={<ProductServiceDetail/>}/> {/* detail package */}

                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/question/:locationType/:packageIndex/:postalCode'}
                    element={(<Question/>)}/>
                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/question/:locationType/:packageIndex'}
                    element={(<Question/>)}/>

                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/postal-code/:locationType/:packageIndex'}
                    element={(<PortalCode/>)}/>

                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/booking/:locationType/:packageIndex/:postalCode'}
                    element={(<Booking/>)}/>
                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/booking/:locationType/:packageIndex'}
                    element={(<Booking/>)}/>

                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/confirm/:locationType/:packageIndex/:postalCode'}
                    element={<Confirm/>}/>
                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/:quantity/confirm/:locationType/:packageIndex'}
                    element={<Confirm/>}/>

                <Route
                    path={'/:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:productServiceTemplateId/thankyou'}
                    element={<Success/>}/>
                <Route path={'/:clientCode/call/:threadId/:roomId/:callType/join'} element={<OutsideCall/>}/>
                <Route path={'/:clientCode/chat/:bookingId/join'} element={<AnonymousChat/>}/>
                <Route path={'/:clientCode/:campaignPath/:bookingId/direct-chat/join'} element={<AnonymousChat/>}/>
                <Route path={'/:clientCode/chat/join'} element={<AnonymousChat/>}/>
                <Route path={'/:clientCode/:campaignPath/401'} element={<ReAuth/>}/>
                <Route path={'/:clientCode/*'} element={<NotFound/>}/>
                <Route path={'/*'} element={<NotFound/>}/>
            </AnimatedSwitch>
            <ScrollToTop/>
        </ThemeProvider>
    )
}

// The router basename is WHERE THE APP IS SERVED, which is independent of
// PUBLIC_URL (the asset-path prefix). On a dedicated prod domain the app is
// served at the root even though its assets live under /customer, so the
// basename must be '/' there — using PUBLIC_URL (/customer) as the basename made
// the router reject every root path (/:clientCode/...) and render a blank page.
// REACT_APP_ROUTER_BASENAME overrides explicitly (set to '/' for prod root);
// when unset it falls back to PUBLIC_URL for sub-path mounts (stg /customer/).
const ROUTER_BASENAME = process.env.REACT_APP_ROUTER_BASENAME != null
    ? process.env.REACT_APP_ROUTER_BASENAME
    : (process.env.PUBLIC_URL || '');
root.render(
    <BrowserRouter basename={ROUTER_BASENAME}>
        <MaintainProvider>
            <AppProvider>
                <App/>
            </AppProvider>
        </MaintainProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
